import { PRIORITY_RANK } from '@/entities/shared/priority/priority-rank';
import type { ShoppingItem } from '../schemas/shopping-item';

/** Most urgent first: priority, then the date it is needed by, then name. */
export function compareShopping(a: ShoppingItem, b: ShoppingItem): number {
  return (
    PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority] ||
    (a.needed_by ?? '9999').localeCompare(b.needed_by ?? '9999') ||
    a.name.localeCompare(b.name, 'es')
  );
}
